import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AsLinkButton from '../../buttons/AsLinkButton';
import Link from '../../links/Link';
import Notice from '../../misc/Notice';
import Sanitise from '../../utilities/Sanitise';
import 'array-flat-polyfill';

function SummaryErrors({ prompt, errors, onErrorPress }) {
  const { t } = useTranslation();
  const ref = useRef(null);

  useEffect(() => {
    ref.current && ref.current.scrollIntoView();
  }, [errors]);

  const total = Object.values(errors).flat().length;

  if (total === 0) {
    return null;
  }

  return (
    <div className={'form__errors'}>
      <Notice type="warning-alert">
        <span ref={ref}>
          {prompt ? (
            prompt(total)
          ) : (
            <Sanitise
              string={
                total === 1
                  ? t('styleguide:error_summary', { count: total })
                  : t('styleguide:errors_summary', { count: total })
              }
            />
          )}
        </span>
        <ul>
          {Object.entries(errors).map(([field, messages]) =>
            messages.map((message, index) => (
              <li key={index}>
                {field === 'global' ? (
                  <p>{message}</p>
                ) : onErrorPress ? (
                  <AsLinkButton onPress={() => onErrorPress(field)}>{message}</AsLinkButton>
                ) : (
                  <Link href={`#${field}`}>{message}</Link>
                )}
              </li>
            ))
          )}
        </ul>
      </Notice>
    </div>
  );
}

SummaryErrors.propTypes = {
  /**
   * The prompt render function
   */
  prompt: PropTypes.func,
  /**
   * The errors
   */
  errors: PropTypes.object,
  /**
   * The error press handler
   */
  onErrorPress: PropTypes.func
};

export default SummaryErrors;
